import { Types } from '../actionTypes'
import { clearAuth } from '../../api/api'

const initialState = {
  id: -1,
  email: '',
  uid: '',
  name: '',
  first_name: '',
  last_name: '',
  building_id: -1,
  tenants: ["public"],
  companies: [],
  visitDestinations: [],
  buildings: [],
  enabled_visit_photo: false,
  enabled_visit_qr: false,
  enabled_identification_photo: false,
  save_identification_photo: false,
  enabled_local_ocr: true,
  enabled_lobby_preregister: true,
  enabled_black_list_by_name: false,
  enabled_costa_rica: false,
  ask_visit_identification: true,
  custom_visit_identification_label: '',
  company: {},
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_DOMAIN:
      const domain = action.payload
      state.domain = domain
      localStorage.setItem('domain', domain)
      return state
    case Types.SET_AUTH:
      const {
        id = -1,
        email = '',
        uid = '',
        name = '',
        first_name = '',
        last_name = '',
        building_id = -1,
        tenants = ['public'],
      } = action.payload.data

      const {
        enabled_visit_photo = false,
        enabled_visit_qr = false,
        enabled_identification_photo = false,
        save_identification_photo = false,
        enabled_local_ocr = true,
        enabled_lobby_preregister = true,
        enabled_black_list_by_name = false,
        enabled_costa_rica = false,
        ask_visit_identification = true,
        enabled_visit_types = false,
        enabled_visit_host = false,
        ask_visit_comes_from = false,
        ask_visit_laptop = false,
        ask_visit_card_number = false,
        ask_visit_license_plate = false,
        visit_types = [],
        custom_visit_identification_label = '',
        // Enviados por CorporateService dentro de `tenant` (no de `data`,
        // que solo serializa el modelo User): ver
        // sessions_controller.rb#render_create_success.
        workplace_default_entry_time = '07:00',
        workplace_default_exit_time = '18:00',
      } = action.payload.tenant

      const goHome = state.goHome + 1

      return {
        ...state,
        id,
        email,
        uid,
        name,
        first_name,
        last_name,
        building_id,
        tenants,
        goHome,
        enabled_visit_photo,
        enabled_visit_qr,
        enabled_identification_photo,
        save_identification_photo,
        enabled_local_ocr,
        enabled_lobby_preregister,
        enabled_black_list_by_name,
        enabled_costa_rica,
        ask_visit_identification,
        enabled_visit_types,
        enabled_visit_host,
        visit_types,
        ask_visit_comes_from,
        ask_visit_laptop,
        ask_visit_card_number,
        ask_visit_license_plate,
        custom_visit_identification_label,
        workplace_default_entry_time,
        workplace_default_exit_time,
      }
    case Types.CLEAN_AUTH:
      clearAuth()
      return initialState
    case Types.SET_COMPANIES:
      return {
        ...state,
        companies: action.payload
      }
    case Types.SET_BUILDINGS:
      return {
        ...state,
        buildings: action.payload
      }
    case Types.SET_BUILDING:
      return {
        ...state,
        building_id: action.payload
      }
    case Types.SET_VISIT_DESTINATIONS:
      return {
        ...state,
        visitDestinations: action.payload
      }
    default:
      return state
  }
}

export default reducer;